import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchUnusedRoles } from 'api/unused-role.service';
import { RoleModel } from 'types/entity';

export const UNUSED_ROLE_READ_STORE_NAME = 'unusedRoleRead';

export const loadUnUsedRoles = createAsyncThunk(
  `${UNUSED_ROLE_READ_STORE_NAME}/loadUnusedRoles`,
  async (projectId: string) => {
    const response = await fetchUnusedRoles(projectId);
    return response;
  },
);

export interface UnusedRoleReadState {
  roles: RoleModel[]
  loaded: boolean
  error: any
}

export const initialUnusedRoleReadState: UnusedRoleReadState = {
  roles: [],
  loaded: false,
  error: null,
};

export const unusedRoleReadSlice = createSlice({
  name: UNUSED_ROLE_READ_STORE_NAME,
  initialState: initialUnusedRoleReadState,
  reducers: {
    replaceAll: (state, action: PayloadAction<RoleModel[]>) => {
      state.roles = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadUnUsedRoles.pending, (state) => {
      state.loaded = false;
    });
    builder.addCase(loadUnUsedRoles.fulfilled, (state, action) => {
      state.roles = action.payload;
      state.loaded = true;
    });
    builder.addCase(loadUnUsedRoles.rejected, (state, action) => {
      state.error = action.payload;
      state.loaded = true;
    });
  },
});

export const unusedRoleReadActions = {
  ...unusedRoleReadSlice.actions,
  loadUnUsedRoles,
};

export default unusedRoleReadSlice.reducer;
